import styled from 'styled-components';
import Button from '@klv/atoms/button/variants/button';
import TextInput from '@klv/molecules/form-field/text';

export const Container = styled.div`
  width: 100%;
`;
export const StyledDynamicTextFormField = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const StyledDeleteButton = styled(Button)`
  margin-left: 1rem;
`;

export const StyledAddButton = styled(Button)<{ $disabled?: boolean; }>`
  ${({ $disabled }) => $disabled && `
    pointer-events: none;
    opacity: 0.5;
  `}
  color: ${({ theme })=> theme.dynamicTextFormField.addButtonColor};
  text-decoration: underline;
  text-underline-offset: 2px;
  margin-bottom: 2.5rem;
`;

export const StyledButtonContainer = styled.div`
  
`;
export const TextInputWrapper = styled.div`
  flex: 1;
`;
export const StyledTextInput = styled(TextInput)`
  width: 100%;
`;
